import React from 'react';
import './App.scss';
import { SellerNetForm } from './components';

function App() {
	return <SellerNetForm />;
}

export default App;
